import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Chip,
  Avatar,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import {
  Search as SearchIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  WhatsApp as WhatsAppIcon,
  LocationOn as LocationIcon,
  Business as BusinessIcon,
  CalendarToday as CalendarIcon,
  Assignment as AssignmentIcon,
  Schedule as ScheduleIcon,
  Email as EmailIcon,
  Timeline as TimelineIcon,
  EventAvailable as VisitIcon,
} from '@mui/icons-material';
import { useLocation } from 'react-router-dom';

const SiteVisitTimeline = () => {
  const location = useLocation();
  const visitDataFromState = location.state?.visitData || {};

  const [selectedAssociate, setSelectedAssociate] = useState('');
  const [selectedVisitId, setSelectedVisitId] = useState('');
  const [selectedVisit, setSelectedVisit] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);

  // Mock site visit data with timeline
  const visitsData = [
    {
      id: 1,
      visitId: 'VT168',
      leadId: 'LD625',
      name: 'ajay',
      phone: '8768686776',
      whatsapp: '8768686776',
      email: 'ajay@example.com',
      visitCreatedOn: '10-06-2025',
      leadCreatedOn: '10-06-2025',
      visitedBy: 'admin ',
      createdBy: 'admin ',
      address: 'Not Provided',
      city: 'Not Provided',
      state: 'Not Provided',
      projectName: 'N/A',
      status: 'HOT',
      timelineDetails: [
        {
          id: 1,
          date: '10-06-2025 13:09:53',
          type: 'Visit',
          remark: 'test',
          nextFollowUp: '10-06-2025 13:09:00',
          status: 'HOT',
          performedBy: 'admin ',
        },
        {
          id: 2,
          date: '10-06-2025 13:08:23',
          type: 'Lead',
          remark: 'test',
          nextFollowUp: '10-06-2025 13:08:00',
          status: 'HOT',
          performedBy: 'admin ',
        },
        {
          id: 3,
          date: '10-06-2025 13:06:00',
          type: 'Lead',
          remark: 'test',
          nextFollowUp: '',
          status: 'Not Interested',
          performedBy: 'admin ',
        },
        {
          id: 4,
          date: '10-06-2025 13:06:00',
          type: 'Lead',
          remark: 'visit',
          nextFollowUp: '10-06-2025 13:06:00',
          status: 'READY TO VISIT',
          performedBy: 'admin ',
        },
        {
          id: 5,
          date: '10-06-2025 13:03:00',
          type: 'Lead',
          remark: 'call again',
          nextFollowUp: '10-06-2025 19:00:00',
          status: '50% intrested',
          performedBy: 'admin ',
        },
      ],
    },
    {
      id: 2,
      visitId: 'VT169',
      leadId: 'LD626',
      name: 'Priya Sharma',
      phone: '+91-9876543211',
      whatsapp: '+91-9876543211',
      email: 'priya.sharma@email.com',
      visitCreatedOn: '2024-01-16',
      leadCreatedOn: '2024-01-16',
      visitedBy: 'admin ',
      createdBy: 'admin ',
      address: 'Mumbai, Maharashtra',
      city: 'Mumbai',
      state: 'Maharashtra',
      projectName: 'Luxury Villas',
      status: 'WARM',
      timelineDetails: [
        {
          id: 1,
          date: '2024-01-16 09:00 AM',
          type: 'Visit',
          remark: 'Site visit conducted successfully',
          nextFollowUp: '2024-01-22',
          status: 'Completed',
          performedBy: 'admin ',
        },
        {
          id: 2,
          date: '2024-01-19 03:30 PM',
          type: 'Follow-up',
          remark: 'Follow-up call scheduled',
          nextFollowUp: '2024-01-22',
          status: 'Scheduled',
          performedBy: 'admin ',
        },
      ],
    },
    {
      id: 3,
      visitId: 'VT170',
      leadId: 'LD627',
      name: 'Amit Patel',
      phone: '+91-9876543212',
      whatsapp: '+91-9876543212',
      email: 'amit.patel@email.com',
      visitCreatedOn: '2024-01-17',
      leadCreatedOn: '2024-01-17',
      visitedBy: 'admin ',
      createdBy: 'admin ',
      address: 'Delhi, Delhi',
      city: 'Delhi',
      state: 'Delhi',
      projectName: 'Modern Apartments',
      status: 'COLD',
      timelineDetails: [
        {
          id: 1,
          date: '2024-01-17 10:00 AM',
          type: 'Visit',
          remark: 'Initial site visit',
          nextFollowUp: '2024-01-25',
          status: 'Completed',
          performedBy: 'admin ',
        },
        {
          id: 2,
          date: '2024-01-20 04:00 PM',
          type: 'Follow-up',
          remark: 'Follow-up call',
          nextFollowUp: '2024-01-28',
          status: 'Pending',
          performedBy: 'admin ',
        },
      ],
    },
  ];

  // Auto-load visit data if passed from navigation
  useEffect(() => {
    if (visitDataFromState?.id || visitDataFromState?.visitId) {
      const visitId = visitDataFromState.visitId || visitDataFromState.id;
      setSelectedVisitId(visitId);
      // Find matching visit in data
      const foundVisit = visitsData.find(
        (v) => v.visitId === visitId || v.leadId === visitDataFromState.leadId
      );
      if (foundVisit) {
        setSelectedVisit(foundVisit);
        setHasSearched(true);
        setSelectedAssociate(foundVisit.visitedBy);
      } else {
        // Use the passed visit data directly with timeline
        setSelectedVisit({
          id: visitDataFromState.id,
          visitId: visitDataFromState.visitId,
          leadId: visitDataFromState.leadId,
          name: visitDataFromState.name,
          phone: visitDataFromState.phone,
          whatsapp: visitDataFromState.whatsapp || visitDataFromState.phone,
          email: visitDataFromState.email || '-',
          visitCreatedOn: visitDataFromState.visitCreatedOn || '-',
          leadCreatedOn: visitDataFromState.leadCreatedOn || '-',
          visitedBy: visitDataFromState.visitedBy || 'admin ',
          createdBy: visitDataFromState.createdBy || 'admin ',
          address: visitDataFromState.address || 'Not Provided',
          city: visitDataFromState.city || 'Not Provided',
          state: visitDataFromState.state || 'Not Provided',
          projectName: visitDataFromState.projectInterested || 'N/A',
          status: visitDataFromState.status || 'HOT',
          timelineDetails: [
            {
              id: 1,
              date: new Date().toLocaleString('en-GB'),
              type: 'Visit',
              remark: visitDataFromState.visitRemark || 'Site visit recorded',
              nextFollowUp: visitDataFromState.nextFollowUp || '-',
              status: visitDataFromState.status || 'HOT',
              performedBy: visitDataFromState.visitedBy || 'admin ',
            },
          ],
        });
        setHasSearched(true);
        setSelectedAssociate(visitDataFromState.visitedBy || '');
      }
    }
  }, [visitDataFromState]);

  // Mock associate data
  const associates = [
    'admin ',
    'Amit Sharma',
    'Priya Singh',
    'Rahul Kumar',
    'Sneha Patel',
    'Vikram Mehta',
    'Anita Desai',
    'Karan Malhotra',
  ];

  // Get all visits or filter by associate
  const getAvailableVisits = () => {
    if (!selectedAssociate) {
      return visitsData;
    }
    return visitsData.filter(
      (visit) =>
        visit.createdBy === selectedAssociate ||
        visit.visitedBy === selectedAssociate
    );
  };

  const availableVisits = getAvailableVisits();

  const handleSearch = () => {
    if (selectedVisitId) {
      const visit = visitsData.find((v) => v.visitId === selectedVisitId || v.leadId === selectedVisitId);
      setSelectedVisit(visit);
      setHasSearched(true);
    } else {
      setSelectedVisit(null);
      setHasSearched(true);
    }
  };

  const getAvatarInitials = (name) => {
    const nameParts = (name || '').trim().split(' ');
    if (nameParts.length === 1) {
      return name.charAt(0).toUpperCase() + (name.charAt(1) || '').toUpperCase();
    }
    const firstName = nameParts[0];
    const lastName = nameParts[nameParts.length - 1];
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const getAvatarColor = (name) => {
    const colors = [
      '#1976d2',
      '#d32f2f',
      '#388e3c',
      '#f57c00',
      '#7b1fa2',
      '#0097a7',
      '#c2185b',
      '#5d4037',
      '#455a64',
      '#00796b',
    ];
    const index = (name || '').charCodeAt(0) % colors.length;
    return colors[index];
  };

  const getStatusColor = (status) => {
    switch (status?.toUpperCase()) {
      case 'HOT':
      case 'COMPLETED':
        return { backgroundColor: '#f44336', color: 'white' };
      case 'WARM':
      case 'SCHEDULED':
        return { backgroundColor: '#ff9800', color: 'white' };
      case 'COLD':
      case 'PENDING':
        return { backgroundColor: '#2196f3', color: 'white' };
      case 'READY TO VISIT':
        return { backgroundColor: '#4caf50', color: 'white' };
      case '50% INTRESTED':
      case '50% intrested':
        return { backgroundColor: '#ff9800', color: 'white' };
      case 'NOT INTERESTED':
        return { backgroundColor: '#9e9e9e', color: 'white' };
      default:
        return { backgroundColor: '#9e9e9e', color: 'white' };
    }
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f9f9fb', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#000', mb: 0.5 }}>
          Site Visit Timeline
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Search and track site visit activities
        </Typography>
      </Box>

      {/* Search Section */}
      <Card sx={{ mb: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.1)', borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#000' }}>
            Visit Detail
          </Typography>
          <Grid container spacing={2} alignItems="center">
            {/* Associate Dropdown */}
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Associate Name</InputLabel>
                <Select
                  value={selectedAssociate}
                  onChange={(e) => {
                    setSelectedAssociate(e.target.value);
                    setSelectedVisitId(''); // Reset visit selection
                  }}
                  label="Associate Name"
                >
                  <MenuItem value="">
                    <em>All Associates</em>
                  </MenuItem>
                  {associates.map((associate) => (
                    <MenuItem key={associate} value={associate}>
                      {associate}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Visit/Lead Dropdown */}
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Visit / Lead</InputLabel>
                <Select
                  value={selectedVisitId}
                  onChange={(e) => setSelectedVisitId(e.target.value)}
                  label="Visit / Lead"
                >
                  <MenuItem value="">
                    <em>Select Visit or Lead</em>
                  </MenuItem>
                  {availableVisits.map((visit) => (
                    <MenuItem key={visit.visitId} value={visit.visitId}>
                      {visit.visitId} / {visit.leadId} - {visit.name} - {visit.phone}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Search Button */}
            <Grid item xs={12} md={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleSearch}
                startIcon={<SearchIcon />}
                sx={{
                  height: 40,
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '15px',
                  boxShadow: '0 4px 12px rgba(83, 109, 254, 0.3)',
                  borderRadius: 1,
                  backgroundColor: '#536DFE',
                  '&:hover': { backgroundColor: '#4058E6' },
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Visit Details Section */}
      {hasSearched && selectedVisit && (
        <Box>
          {/* Visit Information Card */}
          <Card sx={{ mb: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.1)', borderRadius: 2 }}>
            <Box
              sx={{
                p: 2,
                backgroundColor: '#536DFE',
                color: 'white',
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
              }}
            >
              <Box display="flex" alignItems="center" gap={2}>
                <Avatar
                  sx={{
                    bgcolor: 'white',
                    color: '#536DFE',
                    width: 56,
                    height: 56,
                    fontSize: '1.5rem',
                    fontWeight: 700,
                    border: '3px solid white',
                  }}
                >
                  {getAvatarInitials(selectedVisit.name)}
                </Avatar>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h5" sx={{ fontWeight: 700 }}>
                    {selectedVisit.name}
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                    Visit ID: {selectedVisit.visitId} | Lead ID: {selectedVisit.leadId}
                  </Typography>
                </Box>
                <Chip
                  label={selectedVisit.status}
                  sx={{
                    backgroundColor: 'white',
                    color: '#536DFE',
                    fontWeight: 700,
                    fontSize: '14px',
                  }}
                />
              </Box>
            </Box>

            <CardContent sx={{ p: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
                    <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                      <PhoneIcon sx={{ fontSize: 18, color: '#536DFE' }} />
                      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                        Phone Number
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '15px' }}>
                      {selectedVisit.phone}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
                    <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                      <WhatsAppIcon sx={{ fontSize: 18, color: '#25D366' }} />
                      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                        WhatsApp Number
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '15px' }}>
                      {selectedVisit.whatsapp}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
                    <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                      <EmailIcon sx={{ fontSize: 18, color: '#536DFE' }} />
                      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                        Email ID
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '15px' }}>
                      {selectedVisit.email}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
                    <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                      <CalendarIcon sx={{ fontSize: 18, color: '#536DFE' }} />
                      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                        Visit Created On
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '15px' }}>
                      {selectedVisit.visitCreatedOn}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
                    <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                      <PersonIcon sx={{ fontSize: 18, color: '#536DFE' }} />
                      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                        Visited By
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '15px' }}>
                      {selectedVisit.visitedBy}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
                    <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                      <AssignmentIcon sx={{ fontSize: 18, color: '#536DFE' }} />
                      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                        Created By
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '15px' }}>
                      {selectedVisit.createdBy}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
                    <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                      <LocationIcon sx={{ fontSize: 18, color: '#536DFE' }} />
                      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                        Address
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '15px' }}>
                      {selectedVisit.address || `${selectedVisit.city}, ${selectedVisit.state}`}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
                    <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                      <BusinessIcon sx={{ fontSize: 18, color: '#536DFE' }} />
                      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                        Project Interested
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '15px' }}>
                      {selectedVisit.projectName}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Timeline Details Card */}
          <Card sx={{ boxShadow: '0 2px 12px rgba(0,0,0,0.1)', borderRadius: 2 }}>
            <Box
              sx={{
                p: 2,
                backgroundColor: '#536DFE',
                color: 'white',
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <TimelineIcon sx={{ fontSize: 24 }} />
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  Timeline Details
                </Typography>
              </Box>
            </Box>

            <CardContent sx={{ p: 0 }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px' }}>S.No</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px' }}>Date & Time</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px' }}>Type</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px' }}>Remark</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px' }}>Next Follow Up</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px' }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px' }}>Performed By</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedVisit.timelineDetails && selectedVisit.timelineDetails.length > 0 ? (
                      selectedVisit.timelineDetails.map((timeline, index) => (
                        <TableRow key={timeline.id} hover>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '13px' }}>
                              {timeline.date}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={timeline.type}
                              size="small"
                              color="primary"
                              variant="outlined"
                              sx={{ fontWeight: 600, fontSize: '12px' }}
                            />
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontSize: '13px' }}>
                              {timeline.remark}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '13px', color: timeline.nextFollowUp ? '#1976d2' : '#999' }}>
                              {timeline.nextFollowUp || '-'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={timeline.status}
                              size="small"
                              sx={{
                                fontWeight: 600,
                                fontSize: '12px',
                                ...getStatusColor(timeline.status),
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Avatar
                                sx={{
                                  width: 28,
                                  height: 28,
                                  fontSize: '12px',
                                  bgcolor: getAvatarColor(timeline.performedBy),
                                  fontWeight: 700,
                                }}
                              >
                                {getAvatarInitials(timeline.performedBy)}
                              </Avatar>
                              <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '13px' }}>
                                {timeline.performedBy}
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                          <Typography variant="body2" color="text.secondary">
                            No timeline details available
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Box>
      )}

      {/* No Results Message */}
      {hasSearched && !selectedVisit && (
        <Card sx={{ p: 6, textAlign: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.1)', borderRadius: 2 }}>
          <VisitIcon sx={{ fontSize: 64, color: '#ccc', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            No visit found
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please select a visit and click Search to view details
          </Typography>
        </Card>
      )}

      {/* Initial State Message */}
      {!hasSearched && (
        <Card sx={{ p: 6, textAlign: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.1)', borderRadius: 2 }}>
          <VisitIcon sx={{ fontSize: 64, color: '#ccc', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            Select a visit to view timeline
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Choose an associate and visit, then click Search to see their activity details
          </Typography>
        </Card>
      )}
    </Box>
  );
};

export default SiteVisitTimeline;

